import { render, staticRenderFns } from "./scDec.vue?vue&type=template&id=98a44b56&scoped=true"
import script from "./scDec.vue?vue&type=script&lang=js"
export * from "./scDec.vue?vue&type=script&lang=js"
import style0 from "./scDec.vue?vue&type=style&index=0&id=98a44b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a44b56",
  null
  
)

export default component.exports